// extracted by mini-css-extract-plugin
module.exports = {"menuTextColor":"rgba(255,255,255,0.6)","menuActiveTextColor":"#fff"};